<template>
  <div
    v-if="isOpen"
    class="sheet"
    role="dialog"
    aria-modal="true"
    aria-labelledby="create-chooser-title">
    <div class="sheet-backdrop" @click="$emit('on-cancel')" />
    <div class="sheet-container">
      <div class="sheet-handle" aria-hidden="true" />
      <header class="sheet-header">
        <h2 id="create-chooser-title" class="text-[length:var(--type-h3-size)] font-semibold text-text-primary">
          {{ $t('W: Hvad vil du oprette?') }}
        </h2>
      </header>

      <div class="sheet-body flex flex-col gap-sm">
        <UiBaseButton
          isFullWidth
          size="lg"
          :text="$t('W: Ny ordre')"
          type="button"
          @click="$emit('on-select-order')" />
        <UiBaseButton
          isFullWidth
          theme="neutral"
          size="lg"
          :text="$t('W: Nyt projekt')"
          type="button"
          @click="$emit('on-select-project')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// "Lab Customer — Projects, Floor Plans & Samples" plan, Phase 6 — the real
// "+"-button chooser, shown only once `isProjectsEnabled` is true (see
// CustomerNav.vue). Deliberately a fresh, minimal component rather than
// resurrecting the deleted `CreateChooserSheet.vue`/`ProjectPickerSheet.vue`
// from the old mock flow (Phase 6a confirmed those were unreachable dead
// code, not a working reference to restore) — same name reused because it's
// the same job, but the implementation is new. Local isOpen prop + emits,
// matching CloseSampleDraftSheet.vue's existing sheet pattern; there is no
// global sheet-host store in this app to register with.
export default {
  name: 'CreateChooserSheet',
  emits: ['on-cancel', 'on-select-order', 'on-select-project'],
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
